var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.362,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1352",
    d: "M8.672 25h-5.72V13.192H0V8.764a.869.869 0 01.923-.923h2.03V5.074A5.117 5.117 0 013.6 2.491 4.14 4.14 0 015.812.554 5.673 5.673 0 016.827.277a.832.832 0 00.461-.092h.277A31.274 31.274 0 0111.624 0h.738v4.52a.774.774 0 01-.83.83H9.041c-.277.277-.369.369-.369.461v1.938h3.69l-.092.738a15.085 15.085 0 00-.185 2.03c-.092.646-.185 1.384-.277 2.03l-.092.646H8.672zm-4.336-1.384h2.952V11.808h3.321c.092-.461.092-.923.185-1.384a6.535 6.535 0 01.092-1.292H8.3c-.369.092-.554 0-.646-.092a.664.664 0 01-.369-.646V5.812a1.751 1.751 0 011.2-1.568 1.663 1.663 0 01.923-.185h1.384V1.568a21.188 21.188 0 00-3.32.185h-.553c-.277.092-.554.092-.738.185A2.192 2.192 0 004.7 3.137a3.868 3.868 0 00-.461 2.03v3.228a.869.869 0 01-.923.923H1.292V11.9h3.044z",
    fill: "#555"
  })));
}

export default __webpack_public_path__ + "static/media/facebook_sm.846ba4b312ead1861d221828480606f5.svg";
export { SvgFacebookSm as ReactComponent };